import React from "react";

// See https://www.smashingmagazine.com/2020/01/introduction-react-context-api/
// and https://www.toptal.com/react/react-context-api
const MenuContext = React.createContext(["", () => {}]);
export default MenuContext;